import React from 'react';
import classNames from 'classnames';

import styles from './index.sass';

export default ({Element, bare, className, children, ...props}) => {
    if (Element === undefined) {
        Element = 'div';
    }

    return <Element className={classNames(styles.root, {bare}, className)} {...props}>
        {children.map(item => typeof item === 'string'
            ? <a href={item}/>
            : <a href={item.href} title={item.title} dangerouslySetInnerHTML={{__html: item.inner}}/>
        )}
    </Element>
}


// WEBPACK FOOTER //
// ./src/elements/Identities/index.js